let API_POINTS = {
  url: "http://localhost:8080/api/v1",
  socketUrl: "http://localhost:8080/",
};

const SERVER_POINT = process.env.REACT_APP_BUILD_TO || "LOCAL";

switch (SERVER_POINT) {
  case "PROD":
    API_POINTS = {
      url: "https://server.flozy.com/api/v1",
      socketUrl: "https://server.flozy.com/",
    };
    break;
  case "VERCEL":
    API_POINTS = {
      url: "https://api.flozy.com/api/v1",
      socketUrl: "https://api.flozy.com",
    };
    break;
  case "STAGE":
    API_POINTS = {
      url: "https://flozy-backend-dev-1042419926531.us-central1.run.app/api/v1",
      socketUrl:
        "https://flozy-backend-dev-1042419926531.us-central1.run.app/",
    };
    break;
  case "DEV":
    API_POINTS = {
      url: "https://flozy-backend-dev-1042419926531.us-central1.run.app/api/v1",
      socketUrl:
        "https://flozy-backend-dev-1042419926531.us-central1.run.app/",
    };
    break;
  default:
    API_POINTS = {
      url: "http://localhost:8080/api/v1",
      socketUrl: "http://localhost:8080/",
    };
    break;
}

export const _api = API_POINTS;
